import { set } from 'lodash'
const requireContext = require.context('./', true, /\.svg$/)

export default requireContext.keys()
  .reduce(
    (acc, i) => {
      const match = i.match(/(activity|pain|sleep)[/](less|more|same|better|worse)/)
      if (match) {
        const [, type, value] = match
        set(acc, [type, value], requireContext(i))
      }
      return acc
    },
    {} as Record<'sleep'|'pain'|'activity', Record<string, string>>
  )
